var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircleSelect } from '@/components/circle-select.component';
import { useFormContext } from 'react-hook-form';
import { BsCheck2, BsX } from 'react-icons/bs';
import { palette } from '@/theme/palette';
import { useMediaQuery, useTheme } from '@mui/material';
export function PerceivedHearingStatusSelect() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var control = useFormContext().control;
    return (_jsx("div", __assign({ className: "md:m-0 -mt-32" }, { children: _jsx(CircleSelect, { controllerProps: {
                name: 'hearing-loss',
                control: control,
                rules: {
                    required: 'Please select an option',
                },
            }, itemStyles: {
                boxShadow: '0 0 4px 2px #00000022',
                border: '3px solid var(--circle-select-color)',
                svg: {
                    stroke: 'var(--circle-select-color)',
                    strokeWidth: 1.5,
                    width: isMobile ? '50px' : '70px',
                    height: isMobile ? '50px' : '70px',
                },
                '&[data-state="checked"]': {
                    svg: { stroke: 'white' },
                    border: '3px solid white',
                },
                '&:focus': {},
                '&:hover': {
                    backgroundColor: palette.secondary.main,
                    svg: { stroke: 'white' },
                    opacity: 0.8,
                },
                width: isMobile ? '70px' : '100px',
                height: isMobile ? '70px' : '100px',
                margin: isMobile ? '12px' : '16px',
            }, options: [
                {
                    label: 'Yes',
                    value: 'yes',
                    icon: _jsx(BsCheck2, {}),
                },
                {
                    label: 'No',
                    value: 'no',
                    icon: _jsx(BsX, {}),
                },
            ] }) })));
}
